import { Input, InputProps } from './Input';
import * as React from 'react';
import { FieldValues, Path } from 'react-hook-form';

export type IntInputRef = HTMLInputElement;

export interface IntInputProps<T extends FieldValues, TPath extends Path<T>> extends Omit<InputProps<T, TPath>, 'formatFieldValue' | 'formatChangeEventValue'> {
	allowNegative?: boolean;
}

export const IntInput = <T extends FieldValues, TPath extends Path<T>>(props: IntInputProps<T, TPath>) => {

	const { allowNegative, ...rest } = props;

	return (
		<Input
			pattern={getIntPattern(allowNegative ?? false)}
			autoComplete='off'
			// Pongo que son de tipo text para poder manejerlos como queramos y con nuestro Keypad. 
			// Si el usuario quiere cambiar el tipo que lo pase por props
			type='text'
			{...rest}
		/>
	);
};

function getIntPattern(allowNegative: boolean): string {
	return allowNegative ? '-?[0-9]*' : '[0-9]*';
}
